import { BusinessType } from '../../../../data-layer/business/types';
import { UserModel } from '../../../../data-layer/user/types';
import { BusinessRegistrationStatus } from '../../../../mappers/users/toUserModel';
import { BloggerRegistrationUI, BusinessRegistrationUI } from '../../../../ui/business/types';

interface GetVerificationStatusParams {
    businessType: BusinessType;
    currentUser?: UserModel;
    value: BusinessRegistrationUI | BloggerRegistrationUI;
    registrationTgCode?: string;
}

export const getVerificationStatus = ({
    businessType,
    currentUser,
    value,
    registrationTgCode,
}: GetVerificationStatusParams) => {
    const newStatus =
        value.instagramUrl || registrationTgCode
            ? BusinessRegistrationStatus.VERIFICATION
            : BusinessRegistrationStatus.MODERATION;

    if (businessType === BusinessType.BUSINESS || businessType === BusinessType.SERVICE) {
        return {
            businessRegistrationStatus: newStatus,
            bloggerRegistrationStatus: BusinessRegistrationStatus.MULTIPLE_ROLE_RESTRICTED,
            registrationTgCode,
        };
    }
    if (businessType === BusinessType.BLOGGER) {
        return {
            businessRegistrationStatus: BusinessRegistrationStatus.MULTIPLE_ROLE_RESTRICTED,
            bloggerRegistrationStatus: newStatus,
            registrationTgCode,
        };
    }

    return {
        businessRegistrationStatus: currentUser?.businessRegistrationStatus,
        bloggerRegistrationStatus: currentUser?.bloggerRegistrationStatus,
        registrationTgCode,
    };
};
